import React, {ReactNode, ReactElement} from 'react';
import trimClassname from '../../../utils/trimClassname';
import DynamicLink from '../../DynamicLink/DynamicLink';
import Paragraph from '../Text/Paragraph/Paragraph';

import './CardLink.scss';

export interface CardLinkProps {
  href: string;
  icon?: ReactNode;
  label: ReactNode;
  description?: ReactNode;
  className?: string;
  compact?: boolean;
}

const CardLink = ({href, icon, label, description, compact, className}: CardLinkProps): ReactElement => (
  <DynamicLink
    href={href}
    className={trimClassname(`cardLink unstyledLink ${compact ? 'cardLink--compact' : ''} ${className || ''}`)}
  >
    {icon && (
      <div
        className={trimClassname(
          `cardLink__icon ${description || compact ? 'cardLink__icon--top' : ''} ${
            compact ? 'cardLink__icon--compact' : ''
          }`
        )}
      >
        {icon}
      </div>
    )}
    <div className="cardLink__text">
      <Paragraph className={trimClassname(`cardLink__label ${compact ? 'cardLink__label--compact' : ''}`)}>
        {label}
      </Paragraph>
      {!compact && description && <Paragraph className="cardLink__description">{description}</Paragraph>}
    </div>
  </DynamicLink>
);

export default CardLink;
